import React from "react";
import { Route, Switch } from "react-router";
import AutoSeriesPage from "./AutoSeriesPage"
import EditAutoSerialPage from "./EditAutoSerialPage";

export const navLinks = [
    {path: "/auto-series", text: "Auto-series"},
]

export default function GreenApiPage() {
    return (
        <>
            <Switch>
                <Route exact path="/auto-series" component={AutoSeriesPage}/>
                <Route exact path="/auto-series/:view/:id" component={EditAutoSerialPage}/>
                <Route exact path="/auto-series/:edit/:id" component={EditAutoSerialPage}/>
            </Switch>
        </>
    )
}